import axios from "axios";
const BASE_URL = "https://praneeshinfotech.com/kongudevapi/api";

const authApi = axios.create({
    baseURL: BASE_URL,
    headers: {
        "Content-Type": "application/json",
    },
});

export const loginAdmin = async (username, password) => {
    const response = await authApi.post("/auth/login", {
        username,
        password,
    });

    return response.data;
};

export default authApi;